import { createClient } from '../supabase/client';

export const getInterviewsTakenById = async (id: string) => {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('interviews_taken')
    .select('*')
    .eq('id', id)
    .single();
  return data;
};

export const getInterviewsTakenByCandidateId = async (candidateId: string) => {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('interviews_taken')
    .select(
      `
      *,
      interview_evaluation_status(id, coding_test_score)
    `
    )
    .eq('candidate_id', candidateId)
    .order('created_at', { ascending: false });
  return data;
};

export const getInterviewsCompletedByCandidateId = async (
  candidateId: string
) => {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('interviews_taken')
    .select('*')
    .eq('candidate_id', candidateId)
    .eq('status', 'finished');
  return data;
};

export const getLeadingInterviewTakenByCandidateId = async (
  candidateId: string,
  showQualifiedCandidate?: boolean
) => {
  const supabase = createClient();

  // Focus on best evaluated interview:
  // - Status must be 'finished'
  // - Must have transcript
  // - Evaluation must be completed
  // - Ordered by highest coding test score
  let query = supabase
    .from('interviews_taken')
    .select(
      `
      *,
      interviews(title),
      conversation_id,
      interview_evaluation_status!inner(
        status,
        coding_test_score,
        coding_test_grade
      )
    `
    )
    .eq('candidate_id', candidateId)
    .eq('status', 'finished')
    .not('transcript', 'is', null)
    .eq('interview_evaluation_status.status', 'completed')
    .gt('interview_evaluation_status.coding_test_score', 70);

  // Fallback to original logic if no evaluated interview exists
  const baseQuery = supabase
    .from('interviews_taken')
    .select('*, interviews(title), conversation_id')
    .eq('candidate_id', candidateId)
    .in('status', ['wrap_up', 'finished']);

  const { data: latestInterview, error: latestError } = await baseQuery
    .order('created_at', { ascending: false })
    .limit(1)
    .single();

  if (latestError) {
    console.error('Error getting latest interview', latestError);
    throw latestError;
  }

  return latestInterview;
};
